import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '@/services/firebase';

export type OutgoingTransferStatus =
  | 'pending'
  | 'accepted'
  | 'declined'
  | 'expired';

export function useOutgoingTransferStatus(
  uid: string | null,
  transferId: string | null,
): OutgoingTransferStatus | null {
  const [status, setStatus] = useState<OutgoingTransferStatus | null>(null);

  useEffect(() => {
    if (!uid || !transferId) {
      setStatus(null);
      return;
    }
    setStatus('pending');
    const ref = doc(db, 'users', uid, 'outgoingTransfers', transferId);
    const unsub = onSnapshot(ref, (snap) => {
      const s = snap.data()?.status;
      if (
        s === 'pending' ||
        s === 'accepted' ||
        s === 'declined' ||
        s === 'expired'
      ) {
        setStatus(s);
      }
    });
    return () => unsub();
  }, [uid, transferId]);

  return status;
}
